import { create } from "zustand";

/**
 * Ask Allie panel state (Zustand).
 *
 * Holds the panel chrome only — visibility, size, and which view/tab is showing.
 * The conversation itself stays local to AskAllie.
 *
 * Assistant markdown links render outside the component tree (Bubble.List uses a
 * module-level role config), so they read `minimizePanel` from here rather than
 * having it drilled down as a prop.
 */

// "compact" docks Allie as a card bottom-right: still open and streaming, just
// no longer covering the page the user was sent to.
export const PANEL_SIZE = {
  FULL: "full",
  COMPACT: "compact",
};

export const PANEL_WIDTH = {
  [PANEL_SIZE.FULL]: 420,
  [PANEL_SIZE.COMPACT]: 360,
};

export const PANEL_VIEW = {
  CHAT: "chat",
  HISTORY: "history",
};

export const PANEL_TAB = {
  CHAT: "chat",
  FEEDBACK: "feedback",
};

const INITIAL_PANEL = {
  show: false,
  panelSize: PANEL_SIZE.FULL,
  view: PANEL_VIEW.CHAT,
  activeTab: PANEL_TAB.CHAT,
};

const useAllieStore = create((set) => ({
  ...INITIAL_PANEL,

  openPanel: () => set({ show: true }),

  // Closing resets where the user is looking; minimizing deliberately does not.
  closePanel: () => set({ ...INITIAL_PANEL }),

  // Stays open, so no abort and no session reset. The compact card hides the
  // tabs, which would leave the Feedback tab a dead end — land on chat.
  minimizePanel: () =>
    set({ show: true, panelSize: PANEL_SIZE.COMPACT, activeTab: PANEL_TAB.CHAT }),

  expandPanel: () => set({ panelSize: PANEL_SIZE.FULL }),

  setView: (view) => set({ view }),
  setActiveTab: (activeTab) => set({ activeTab }),
}));

export default useAllieStore;
